export default "__VITE_ASSET__DemJtC8t__"